import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="18" height="18" rx="9" fill="#FAB600" />
    <path
      d="M5.53317 5.00408L9.00001 3L12.4669 5.00408L11.1669 5.70816L9.00001 4.46224L6.77909 5.70816L5.53317 5.00408ZM12.4123 7.49592L11.1663 6.79184L9.00001 8.03776L6.77909 6.79184L5.53317 7.49592V8.95868L7.70001 10.2046V12.7505L8.94593 13.5087L10.1919 12.7505V10.2587L12.3587 9.01276V7.49592H12.4123ZM12.4123 11.5041V10.0418L11.1669 10.8V12.2082L12.4123 11.5041ZM13.3332 11.9918L11.1663 13.2378V14.7L14.6332 12.6959V8.68776L13.3332 9.5V11.9918ZM12.0878 6.25L13.3337 7.00816V8.47092L14.5796 7.71276V6.25L13.3337 5.49184L12.0878 6.25ZM7.70001 13.7791V15.2413L8.94593 15.9995L10.1919 15.2413V13.7791L8.94593 14.5372L7.70001 13.7791ZM5.53317 11.5041L6.77909 12.2082V10.7459L5.53317 9.98776V11.5041ZM7.70001 6.25L8.94593 7.00816L10.2459 6.25L9.00001 5.49184L7.70001 6.25ZM4.61225 7.00816L5.91225 6.25L4.61225 5.49184L3.36685 6.25V7.71224L4.61277 8.4704V7.00816H4.61225ZM4.61225 9.5L3.36633 8.74184V12.75L6.83317 14.7541V13.2918L4.66633 12.0459V9.5H4.61225Z"
      fill="white"
    />
  </svg>
)
